module.exports = new __parcel__URL__("step_four_vector_dark.2f4a898a.png").toString();